// extracted by mini-css-extract-plugin
module.exports =  {"button":"_32bbee5fda--button--goD0Y","icon":"_32bbee5fda--icon--QA8y7"};